module.exports = __webpack_public_path__ + "img/wait.14281c88.svg";